<template>
    <div
        class="
            animate-spin
            before:absolute before:block before:h-full before:w-full before:rounded-full before:border-opacity-30
            after:absolute after:block after:h-full after:w-full after:rounded-full after:border-transparent
        "
        :class="[colorClassName, widthClassName]"
    />
</template>

<script>
    /**
     * Generic loading indicator.
     * @displayName Spinner
     */
    export default {
        name: 'ActivixSpinner',

        props: {
            light: {
                type: Boolean,
                default: false,
            },
            width: {
                type: Number,
                default: 2,
                validator: value => [2, 3, 4].includes(value),
            },
        },

        computed: {
            colorClassName() {
                return this.light
                    ? 'before:border-white after:border-t-white'
                    : 'before:border-gray-600 after:border-t-gray-600';
            },

            widthClassName() {
                return {
                    2: 'before:border-2 after:border-2',
                    3: 'before:border-3 after:border-3',
                    4: 'before:border-4 after:border-4',
                }[this.width];
            },
        },
    };
</script>
